import { hexToRgba } from '../../utils/helpers';

export default function SectionHeader({ children, template, accent }) {
  const style = template.sectionStyle;

  if (style === 'banner' || style === 'banner-underline') {
    return (
      <div
        className="resume-section-header"
        style={{
          background: '#E8E8E8',
          padding: '0.06in 0.12in',
          margin: '0.18in 0 0.1in 0',
          borderBottom: style === 'banner-underline' ? `1.5px solid ${template.accent2 || accent}` : 'none',
          textAlign: 'center',
          letterSpacing: '0.18em',
          fontSize: '10pt',
          fontWeight: 600,
          textTransform: 'uppercase',
          color: accent,
        }}
      >
        {children}
      </div>
    );
  }

  if (style === 'banner-soft') {
    return (
      <div
        className="resume-section-header"
        style={{
          background: hexToRgba(accent, 0.10),
          padding: '0.06in 0.12in',
          margin: '0.18in 0 0.1in 0',
          textAlign: 'center',
          letterSpacing: '0.18em',
          fontSize: '10pt',
          fontWeight: 500,
          textTransform: 'uppercase',
          color: accent,
        }}
      >
        {children}
      </div>
    );
  }

  if (style === 'small-caps-rule') {
    return (
      <div
        className="resume-section-header"
        style={{
          margin: '0.2in 0 0.08in 0',
          paddingBottom: '0.03in',
          borderBottom: `1px solid ${accent}`,
          letterSpacing: '0.22em',
          fontSize: '9.5pt',
          fontWeight: 600,
          textTransform: 'uppercase',
          color: accent,
        }}
      >
        {children}
      </div>
    );
  }

  if (style === 'small-caps-italic') {
    return (
      <div
        className="resume-section-header"
        style={{
          margin: '0.22in 0 0.08in 0',
          paddingBottom: '0.04in',
          borderBottom: `0.5px solid ${accent}`,
          letterSpacing: '0.16em',
          fontSize: '10pt',
          fontStyle: 'italic',
          fontWeight: 400,
          textTransform: 'uppercase',
          color: accent,
        }}
      >
        {children}
      </div>
    );
  }

  return null;
}
